<div class="fullwidth-layout-container" basepage="secondary">
  <div class="row" #prodDetailTitle>
    <div class="col">
      <div class="page-nav-header no-pills">
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="back-container" style="display: flex">
            <button type="button" class="btn btn-transparent p-0" (click)="goBack()" aria-label="back">
              <fa-icon icon="arrow-left" class="circle-icon-btn" aria-hidden="true"></fa-icon>
              <span class="sr-only">back</span>
            </button>
            <div class="d-flex align-items-center">
              <fui-heading [text]="fenderGear?.product?.title || 'Loading...'" [level]="5"></fui-heading>
            </div>
          </div>
          @if (loading) {
            <div>
              <fa-icon icon="spinner" animation="spin"></fa-icon>
              <span style="opacity: 0.4; margin-left: 10px">Loading...</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  @if (!loading && !fenderGear && !snapshotError) {
    <div class="alert alert-warning m-t-20">No Fender gear found with SKU "{{ sku }}".</div>
  }

  @if (dryRun) {
    <div class="alert alert-warning m-t-20 m-b-0">
      <strong>Dry-run mode.</strong>
      Showing what the page would render with the FMIC Products API flag turned on. No snapshot has been written to DynamoDB.
    </div>
  }

  @if (fenderGear) {
    <div class="d-flex align-items-end m-t-20">
      <img [src]="fenderGear.product.imageUrl" style="width: 50px" />
      <div class="m-l-10">
        <span class="fui-heading-font t-30">{{ title || fenderGear.product.title }}</span>
        @if (subTitle) {
          <div class="text-muted t-14">{{ subTitle }}</div>
        }
      </div>
    </div>
    <hr />
    @if (!dryRun) {
      <button class="btn btn-sm btn-secondary" [disabled]="regeneratingSnapshot" (click)="regenerateSnapshot()">
        @if (regeneratingSnapshot) {
          <fa-icon icon="spinner" animation="spin"></fa-icon>
          Regenerating...
        } @else {
          Regenerate Snapshot
        }
      </button>
      <hr />
    }
    @if (sku || headerSeries || headerBodyType || headerType || headerProductNo || isPresonusProductId) {
      <div class="d-flex flex-wrap m-b-20" style="gap: 32px">
        @if (headerSeries) {
          <div>
            <div class="t-12 text-muted text-uppercase">Series</div>
            <div class="t-18 brandfont-bold">{{ headerSeries }}</div>
          </div>
        }
        @if (headerBodyType) {
          <div>
            <div class="t-12 text-muted text-uppercase">Body Type</div>
            <div class="t-18 brandfont-bold">{{ headerBodyType }}</div>
          </div>
        }
        @if (headerType) {
          <div>
            <div class="t-12 text-muted text-uppercase">Type</div>
            <div class="t-18 brandfont-bold">{{ headerType }}</div>
          </div>
        }
        @if (sku) {
          <div>
            <div class="t-12 text-muted text-uppercase">SKU</div>
            <div class="t-18 brandfont-bold">{{ sku }}</div>
          </div>
        }
        @if (isPresonusProductId) {
          <div>
            <div class="t-12 text-muted text-uppercase">{{ "admin_portal.product_id" | translate }}</div>
            <div class="t-18 brandfont-bold">{{ fenderGear.product.id }}</div>
          </div>
        }
        @if (headerProductNo) {
          <div>
            <div class="t-12 text-muted text-uppercase">Product Number</div>
            <a
              class="t-18 brandfont-bold"
              [routerLink]="['/products/fender_products/list']"
              [queryParams]="{ type: 'productNo', value: headerProductNo, run: '1' }"
              ngbTooltip="Search for all variants with this product number"
            >
              {{ headerProductNo }}
            </a>
          </div>
        }
      </div>
    }
    @if (metadataLoaded && headerProductNo) {
      <div class="m-t-20">
        <myp-localized-descriptions-editor
          [metadataKey]="headerProductNo"
          [descriptions]="localizedDescriptions"
          [shortDescriptions]="localizedShortDescriptions"
          [englishDescription]="fenderGear.product.description"
          [englishShortDescription]="fenderGear.product.shortDescription"
        ></myp-localized-descriptions-editor>
      </div>
    } @else if (!headerProductNo) {
      <div class="alert alert-warning t-12 m-t-20">This product has no PIM productNo, so localized descriptions can't be authored for it.</div>
    }

    <fui-associate-learn-content [snapshot]="fenderGear"></fui-associate-learn-content>

    @if (fenderGear.pimSpecs) {
      <div class="m-t-20">
        <h4 class="section-header m-b-10 m-t-30">
          {{ "productDetail.specs" | translate }}
          <span class="section-header-link" (click)="specsCollapsed = !specsCollapsed">
            {{ specsCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
            <fa-icon [icon]="specsCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
          </span>
        </h4>
        @if (!specsCollapsed) {
          <div class="specs-container" [ngStyle]="{ 'max-height': showAllSpecs ? 'none' : '565px' }">
            @for (spec of allSpecs; track spec) {
              <div class="m-b-20">
                <span class="t-16 brandfont-bold">
                  {{ ("productDetail.specSections." + spec.Name | translate) === "productDetail.specSections." + spec.Name ? spec.Name : ("productDetail.specSections." + spec.Name | translate) }}
                </span>
                <div class="guitar-specs-table">
                  @for (item of spec | keyvalue; track item) {
                    @if (item.key != "Name") {
                      <div class="spec-row">
                        <span class="spec-key">
                          {{ ("productDetail.specFields." + item.key | translate) === "productDetail.specFields." + item.key ? item.key : ("productDetail.specFields." + item.key | translate) }}:
                        </span>
                        <span class="spec-value">{{ item.value }}</span>
                      </div>
                    }
                  }
                </div>
              </div>
            }
          </div>
          <button class="brand-btn-reverse sm m-t-20" (click)="showAllSpecs = !showAllSpecs">
            {{ "productDetail.show" | translate }} {{ showAllSpecs ? ("productDetail.less" | translate) : ("productDetail.more" | translate) }}
          </button>
        }
      </div>
    }
  }

  @if (imageRows?.length) {
    <div class="m-t-20">
      <h4 class="section-header m-b-10 m-t-30">
        Images
        <span class="section-header-link" (click)="imagesCollapsed = !imagesCollapsed">
          {{ imagesCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
          <fa-icon [icon]="imagesCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
        </span>
      </h4>
      @if (!imagesCollapsed) {
        @for (row of imageRows; track row.label) {
          <div class="m-b-20">
            <span class="d-block t-14 brandfont-bold m-b-5">{{ row.label }}</span>
            <div class="image-horizontal-scroll">
              @for (url of row.urls; track url) {
                <img [src]="url" (click)="showImage(url)" />
              }
            </div>
          </div>
        }
      }
    </div>
  }

  @if (featureBullets) {
    <div class="m-t-20">
      <h4 class="section-header m-b-10 m-t-30">Feature Bullets</h4>
      <div [innerHTML]="featureBullets | safe: 'html'"></div>
    </div>
  }

  @if (highlights?.length) {
    <div class="m-t-20">
      <h4 class="section-header m-b-10 m-t-30">
        Highlights
        <span class="section-header-link" (click)="highlightsCollapsed = !highlightsCollapsed">
          {{ highlightsCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
          <fa-icon [icon]="highlightsCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
        </span>
      </h4>
      @if (!highlightsCollapsed) {
        <div class="row">
          @for (highlight of highlights; track highlight) {
            <div class="col-md-6 col-lg-4 m-b-50">
              @if (highlight.url) {
                <div class="d-flex justify-content-center">
                  <img [src]="highlight.url" class="w-full" style="border-radius: 10px; max-width: 250px" />
                </div>
              }
              <div class="m-t-10">
                <span class="t-18 brandfont-bold">{{ highlight.title }}</span>
                <br />
                <span class="t-14">{{ highlight.description }}</span>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }

  @if (fenderGear) {
    <div class="m-t-20">
      <h4 class="section-header m-b-10 m-t-30">
        Generated Snapshot
        <span class="section-header-link" (click)="rawSnapshotCollapsed = !rawSnapshotCollapsed">
          {{ rawSnapshotCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
          <fa-icon [icon]="rawSnapshotCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
        </span>
      </h4>
      @if (!rawSnapshotCollapsed) {
        <pre
          style="background: #1e1e1e; color: #d4d4d4; padding: 16px; border-radius: 8px; overflow: auto; height: 800px; resize: vertical; min-height: 200px"
        ><code>{{ fenderGear | json }}</code></pre>
      }
    </div>
  }

  @if (snapshotError) {
    <div class="m-t-20">
      A snapshot could not be created for this product for the following reason:
      <div class="alert alert-danger">
        <code>
          {{ snapshotError }}
        </code>
      </div>
    </div>
  }

  @if (dataSources?.length) {
    <div class="m-t-20">
      <h4 class="section-header m-b-10 m-t-30">
        Data Sources
        <span class="section-header-link" (click)="dataSourcesCollapsed = !dataSourcesCollapsed">
          {{ dataSourcesCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
          <fa-icon [icon]="dataSourcesCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
        </span>
      </h4>

      @if (!dataSourcesCollapsed) {
        @for (dataSource of dataSources; track dataSource) {
          <div class="m-b-20">
            <span class="d-block fui-heading-font t-20" [class.c-red]="dataSource.error">{{ dataSource.source }}</span>
            <span class="d-block t-16">API: {{ dataSource.api }}</span>
            <span class="d-block t-16">Endpoint: {{ dataSource.endpoint }}</span>
            <div>
              @if (dataSource.data) {
                <pre
                  style="background: #1e1e1e; color: #d4d4d4; padding: 16px; border-radius: 8px; overflow: auto; height: 800px; resize: vertical; min-height: 150px"
                ><code>{{ dataSource.data | json }}</code></pre>
              } @else if (dataSource.error) {
                <div style="background: #1e1e1e; color: #d4d4d4; padding: 16px; border-radius: 8px; overflow: auto; height: 800px; resize: vertical; min-height: 150px">
                  <code>Error: {{ dataSource.error }}</code>
                </div>
              }
            </div>
          </div>
        }
      }
    </div>
  }
</div>
<div class="p-b-50"></div>
